<template>
  <div>
    <b-container class="sectionHero">
      <b-row>
        <b-col
          cols="10"
          md="10"
          lg="6"
          xl="6"
          class="sectionHero__text"
        >
          <h1
            class="mb-2 text-dark"
            v-html="resolveHtml(headline)"
          />
          <div
            class="mb-3 sm-linebreak-none"
            v-html="resolveHtml(body)"
          />
          <b-button
            v-if="buttonPrimary"
            :href="buttonPrimaryHref"
            class="mr-2"
            variant="outline-dark"
          >
            {{ buttonPrimaryTitle }}
          </b-button>
          <b-button
            v-if="buttonSecondary"
            :href="buttonSecondaryHref"
            variant="secondary"
          >
            {{ buttonSecondaryTitle }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import RichTextResolver from 'storyblok-js-client/dist/rich-text-resolver.es'
export default {
  name : 'SectionHero',
  props: {
    headline: {
      type   : Object,
      default: null,
    },
    body         : { type: Object, default: null },
    buttonPrimary: {
      type   : Boolean,
      default: false,
    },
    buttonSecondary: {
      type   : Boolean,
      default: false,
    },
    buttonPrimaryTitle: {
      type   : String,
      default: null,
    },
    buttonPrimaryTo: {
      type   : String,
      default: null,
    },
    buttonPrimaryHref: {
      type   : String,
      default: null,
    },
    buttonSecondaryTitle: {
      type   : String,
      default: null,
    },
    buttonSecondaryTo: {
      type   : String,
      default: null,
    },
    buttonSecondaryHref: {
      type   : String,
      default: null,
    },
  },
  methods: {
    resolveHtml (content) {
      const resolver = new RichTextResolver()
      return resolver.render(content)
    },
  },
}
</script>

<style lang="scss" scoped>

.sectionHero {
    padding-top: 6em;
    padding-bottom: 3em;

    @include media-breakpoint-up(lg) {
      padding-top: 8em;
      padding-bottom: 10em;
    }

    @include media-breakpoint-up(xl) {
      padding-top: 10em;
      padding-bottom: 15em;
    }

    &__text {
      z-index: 1;
    }
}
</style>
